import { XMLParser } from 'fast-xml-parser';
// import { toast } from 'react-toastify';

const CACHE_TTL = 60 * 60 * 1000;
const epgCache = new Map();

const monthNames = [
  "Januar", "Februar", "Marec", "April", "Maj", "Jun",
  "Jul", "August", "September", "Oktober", "November", "December"
];

const parserOptions = {
  ignoreAttributes: false,
  attributeNamePrefix: '',
  parseAttributeValue: true,
  alwaysCreateTextNode: true,
  textNodeName: 'text',
  trimValues: true
};

const parser = new XMLParser(parserOptions);

function parseEPGTime(epgTime) {
  const match = epgTime.match(/(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})/);
  if (!match) throw new Error('Invalid EPG time format');
  const [, year, month, day, hour, minute] = match;
  return new Date(+year, +month - 1, +day, +hour, +minute);
}

function isSameDay(d1, d2) {
  return d1.getDate() === d2.getDate() &&
         d1.getMonth() === d2.getMonth() &&
         d1.getFullYear() === d2.getFullYear();
}

function extractTextContent(element) {
  if (!element) return '';
  if (typeof element === 'string') return element;
  if (element.text) return element.text;
  if (typeof element === 'object' && element.constructor === Object) {
    // Handle objects with language attributes
    return element['#text'] || element.text || '';
  }
  return '';
}

async function fetchEPGFile(filename) {
  try {
    const response = await fetch(`/EPG/${filename}`);
    if (!response.ok) throw new Error('EPG file not found');
    const xmlText = await response.text();
    return parser.parse(xmlText);
  } catch (error) {
    console.error('Failed to fetch EPG:', error);
    throw error;
  }
}

export async function getEPGData() {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
  
    const monthName = monthNames[currentDate.getMonth()];
    const yearNumber = currentDate.getFullYear().toString().slice(-2);
    const filename = `${monthName}${yearNumber}.xml`;
  
    if (epgCache.has(filename)) {
      const entry = epgCache.get(filename);
      if (Date.now() - entry.timestamp < CACHE_TTL) {
        return entry.programs;
      }
    }
  
    try {
      const result = await fetchEPGFile(filename);
      const programs = (result.tv?.programme || []).map(p => ({
        // Extract text content properly, handling objects with lang attributes
        title: extractTextContent(p.title) || 'No title',
        description: extractTextContent(p.desc) || '',
        start: parseEPGTime(p.start),
        end: parseEPGTime(p.stop),
        channel: p.channel || 'unknown'
      }));
  
      // Cache the result
      epgCache.set(filename, {
        programs: programs.filter(p => isSameDay(p.start, currentDate)),
        timestamp: Date.now()
      });
  
      return epgCache.get(filename).programs;
    } catch (error) {
      console.log(`EPG file ${filename} not found`);
      
      // Show error toast with same style as current program toast
      // toast(
      //   <div>
      //     <div style={{ color: '#ffcccc', fontSize: '0.88rem', marginBottom: 1 }}>
      //       Program Guide Error:
      //     </div>
      //     <div className="program-title">
      //       No EPG data available for {monthName} {currentDate.getFullYear()}
      //     </div>
      //     <div className="program-description">
      //       Please check back later for program information.
      //     </div>
      //   </div>,
      //   {
      //     position: "bottom-right",
      //     autoClose: 8000,
      //     hideProgressBar: true,
      //     closeOnClick: true,
      //     progress: undefined,
      //     className: 'epg-entry text-danger',
      //     type: 'error'
      //   }
      // );
      
      // Throw error to be caught by EPGList component
      throw new Error(`No program guide available for ${monthName} ${currentDate.getFullYear()}`);
    }
  }